import styled, { css } from 'styled-components';
import { prefix } from '../../tools/settings';
export var StyledImage = styled.img.withConfig({
  displayName: "Imagestyles__StyledImage",
  componentId: "sc-a0fump-0"
})(["&.", "-image--rounded{border-radius:9999px;}", " object-fit:", ";"], prefix, function (props) {
  return props.size && css(["height:", ";width:", ";"], props.size, props.size);
}, function (props) {
  return props.objectFit;
});